import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import CookieWarningComponent from './js/cookie-warning.component';

ComponentsFactory.getInstance().define('cookie-warning', CookieWarningComponent);
